module.exports = __webpack_public_path__ + "img/RCretanBowman64_ua.59d05001.webp";